// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import SEO from "@/components/SEO";

function formatErr(detail) {
  if (!detail) return "Something went wrong.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e.msg || JSON.stringify(e)).join(" ");
  return String(detail);
}

export default function Register() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const { register } = useAuth();
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await register(email, password, name);
      toast.success("Welcome to the pack!");
      navigate("/onboarding");
    } catch (err) {
      toast.error(formatErr(err.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-[calc(100vh-80px)] grid lg:grid-cols-2">
      <SEO title="Join the Pack" path="/register" description="Create your free OSCR account — join Odisha's running community in seconds. Email signup or Google login. From beginner to ultra, every runner is welcome." />
      <div className="flex items-center justify-center p-8 sm:p-16 order-2 lg:order-1">
        <form onSubmit={submit} className="w-full max-w-md" data-testid="register-form">
          <h1 className="font-display text-3xl text-white">Create your account</h1>
          <p className="text-sm text-zinc-400 mt-1">Join Odisha Steel City Runners.</p>

          <div className="mt-8 space-y-4">
            <div>
              <Label className="font-display tracking-widest text-xs text-zinc-400">FULL NAME</Label>
              <Input data-testid="register-name" value={name} onChange={(e) => setName(e.target.value)} required className="mt-2 rounded-none bg-zinc-900 border-zinc-800 text-white focus-visible:ring-orange-600" />
            </div>
            <div>
              <Label className="font-display tracking-widest text-xs text-zinc-400">EMAIL</Label>
              <Input data-testid="register-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="mt-2 rounded-none bg-zinc-900 border-zinc-800 text-white focus-visible:ring-orange-600" />
            </div>
            <div>
              <Label className="font-display tracking-widest text-xs text-zinc-400">PASSWORD</Label>
              <Input data-testid="register-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required minLength={6} className="mt-2 rounded-none bg-zinc-900 border-zinc-800 text-white focus-visible:ring-orange-600" />
            </div>
            <Button data-testid="register-submit-btn" type="submit" disabled={busy} className="w-full rounded-none bg-orange-600 hover:bg-orange-500 font-display tracking-wider text-base py-6">
              {busy ? "CREATING…" : "JOIN THE PACK"}
            </Button>
          </div>

          <p className="text-sm text-zinc-400 mt-8 text-center">
            Already a member?{" "}
            <Link to="/login" className="text-orange-500 hover:text-orange-400 font-semibold">
              Log in
            </Link>
          </p>
        </form>
      </div>
      <div className="hidden lg:block relative order-1 lg:order-2">
        <img src="https://images.pexels.com/photos/672630/pexels-photo-672630.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=940" alt="Konark Sun Temple chariot wheel, Odisha" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-tl from-zinc-950 via-zinc-950/60 to-transparent" />
        <div className="relative h-full flex items-end p-12">
          <div>
            <p className="font-mono text-xs tracking-[0.3em] text-orange-500 uppercase">OSCR · NEW RUNNER</p>
            <h2 className="font-display text-5xl text-white mt-3 max-w-md leading-none">
              Your first mile starts here.
            </h2>
          </div>
        </div>
      </div>
    </div>
  );
}
